define.alias("shared/components/shared/social/basic-display-deprecation/wizard", "media/components/shared/social/basic-display-deprecation/wizard");